import React from 'react';

const cellTypes = {
  'number': {
    className: 'numberCell'
  },
  '#': {
    className: 'poundCell'
  },
  'null': {
    className: 'nullCell'
  }
};

const cell = React.forwardRef((props, ref) => {
  let contents = null;
  if (props.type == 'number') {
    contents = (
      <React.Fragment>
        <div className="cellNumber">{props.number}</div>
        <div className="cellAnswer">{props.answer}</div>
      </React.Fragment>
    );
  } else if (props.type == 'null') {
    contents = (
      <div className="cellAnswer">{props.answer}</div>
    );
  }

  const classes = [cellTypes[props.type].className];
  if (props.isFocused) {
    classes.push('cellFocused');
  } else {
    classes.push('cellBlurred');
  }
  if (props.isWrong) {
    classes.push('cellWrong');
  }

  const handleFocus = (e) => {
    // After closing a dialog that's invoked from a cell
    // change, the select() method might not be there.
    // Presumably because the input was hidden?
    if (typeof event.target.select === 'function') {
      event.target.select()
    }
    props.onInputFocus(e);
  };
  
  const handleKeyDown = (e) => {
    if (typeof props.onArrowKey === 'function') {
      const arrowKeys = {
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down'
      };
      const direction = arrowKeys[e.keyCode];
      if (direction) {
        props.onArrowKey(direction, props.cellkey);
      }
    }
  };

  let input = null;
  if (props.playable) {
    input = (
      <input type="text" className="cellInput" maxLength="1"
             disabled={props.type === '#' && !props.crosswordEditable}
             onChange={props.onInputChange}
             value={props.answer}
             cellkey={props.cellkey} 
             onFocus={handleFocus}
             onBlur={props.onInputBlur}
             onKeyDown={handleKeyDown}
             ref={ref} />
    );
  }

  return (
    <td className={classes.join(' ')} >
      {contents}
      {input}
    </td>
  );
});

export default cell;
